export const mqttTopicGatewayVersion = 'summa/gateway/version';

export const applicationTypeAPI = 'API';
export const applicationTypeMS = 'Microservice';

const applicationType = [applicationTypeAPI, applicationTypeMS] as const;

export type ApplicationType = typeof applicationType[number];
